import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faUsers, faCalendarAlt } from '@fortawesome/free-solid-svg-icons';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import '../../Styles/HomePageSlider.css'


const HomePageSlider = () => {
  const navigate = useNavigate();


  const pages = [
    { name: 'Månedsrapport', path: '/månedsrapport', icon: faCalendarAlt },
    { name: 'Strategi', path: '/strategi', icon: faChartLine },
    { name: 'Rollefordeling', path: '/rollefordeling', icon: faUsers }
  ];

  return (
    <Swiper
      modules={[Navigation,  Scrollbar]}
      spaceBetween={50}
      slidesPerView={1}
      navigation
      speed={800}
      effect={"fade"}
      loop={true}
      scrollbar={{ draggable: true }}
      onSlideChange={() => console.log('slide change')}
    >
      {pages.map((page) => (
        <SwiperSlide key={page.name} style={{ backgroundColor: "#001633" }}>
          <div className="slide-content" onClick={() => navigate(page.path)}>
            <FontAwesomeIcon icon={page.icon} size="3x" style={{ color: "#FD6925" }} />
            <h2 style={{color: "#FD6925"}}>{page.name}</h2>
          </div>
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default HomePageSlider;


